import React from 'react';
import { Dialog, DialogButtons, DialogContent, DialogTitle } from '@/Components/Dialog/Dialog';
import { Procedure } from '@/Components/Procedure/Procedure';
import WorklistStore from '@/Pages/GenericWorklist/Stores/WorklistStore';
import { DobAlert, DobButton } from '@dedalusdiit/dob-components';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

interface UpgradeProcedureDialogProps {
    worklistStore: WorklistStore;
    open: boolean;
}

const UpgradeProcedureDialog = observer((props: Readonly<UpgradeProcedureDialogProps>): React.ReactElement => {
    const { t } = useTranslation();
    const { worklistStore } = props;

    if (!worklistStore.reportUpgradeProcedure) {
        return <></>;
    }

    const procedureItem = {
        StatusIndicator: worklistStore.reportUpgradeProcedure.StatusIndicator,
        Modality_Text: worklistStore.reportUpgradeProcedure.Modality_Text,
        Description: worklistStore.reportUpgradeProcedure.Description,
        Room_Text: worklistStore.reportUpgradeProcedure.Room_Text,
        Radiologist_Text: worklistStore.reportUpgradeProcedure.Radiologist_Text,
        Color: worklistStore.reportUpgradeProcedure.Color,
        Code: worklistStore.reportUpgradeProcedure.Code,
    };

    return (
        <Dialog open={props.open}>
            <DialogTitle>{t('ChangeProcedureToCompleted')}</DialogTitle>
            <DialogContent flexCenter>
                <Procedure item={procedureItem} />
                <br />
                <DobAlert type="warning">
                    {t('InfoUpgradeProcedureStatus')}
                    <br />
                    {t('QuestionSureUpgradeProcedureStatus')}
                    {' '}
                    <b>{worklistStore.reportUpgradeProcedure.Status_Text}</b>
                    {' '}
                    {t('to')}
                    {' '}
                    <b>{t('Completed')}</b>
                    <span>?</span>
                </DobAlert>
            </DialogContent>
            <DialogButtons>
                <DobButton
                    color="secondary"
                    onClick={() => props.worklistStore.setReportProcedureUpgradeDialogOpen(false)}
                >
                    {t('Cancel')}
                </DobButton>
                <DobButton
                    onClick={() => props.worklistStore.upgradeProcedureStatus(props.worklistStore.reportUpgradeProcedure?.OrderHasProcedure_UID)}
                >
                    {t('Ok')}
                </DobButton>
            </DialogButtons>
        </Dialog>
    );
});

export default UpgradeProcedureDialog;
